import React from 'react';
import { UserAvatarAndName } from '@shared/ui/molecules/UserAvatarAndName';
import { UNKNOWN_OPTION, WhereaboutsOption } from '@features/whereabouts/services/WhereaboutOptions';
import { MemberMovements } from '@features/whereabouts/models/movements.models';
import { IconPack } from '@shared/models/company.models';
import { DailyDayCells } from './DailyDayCells';
import { TeamHeader, TeamSection } from './WhereaboutsV2Styles';

interface Props {
  userId: string;
  firstname: string;
  lastname: string;
  currentUserData: MemberMovements | null;
  getOption: (statusId: number) => WhereaboutsOption;
  officeNameMap: Map<number, string>;
  iconPack: IconPack;
  dateStr: string;
}

export function DailyCurrentUserSection({ userId, firstname, lastname, currentUserData, getOption, officeNameMap, iconPack, dateStr }: Props) {
  const dayData = (currentUserData?.whereabouts ?? []).find(w => w.date === dateStr);
  const amOption = dayData ? getOption(dayData.amStatusId) : UNKNOWN_OPTION;
  const pmOption = dayData ? getOption(dayData.pmStatusId) : UNKNOWN_OPTION;

  return (
    <TeamSection>
      <TeamHeader>
        <UserAvatarAndName firstName={firstname} lastName={lastname} colour="blue" showEditLink={true} />
      </TeamHeader>
      <DailyDayCells userId={userId}
                     firstName={firstname}
                     lastName={lastname}
                     dayData={dayData}
                     amOption={amOption}
                     pmOption={pmOption}
                     officeNameMap={officeNameMap}
                     iconPack={iconPack}
                     dateStr={dateStr}
                     showOptionLabel={true} />
    </TeamSection>
  );
}
